import { RootState } from "../store";
import { PARTNER_LOGO_MAP } from "../../Components/Partner/onboardingConstants";

export const selectIsPartner = (state: RootState) =>
  state.partner.isPartnerLoggedIn;

export const selectPartnerVariant = (state: RootState) =>
  state.partner.variant;

export const selectPartnerConfig = (state: RootState) =>
  state.partner.config;

// Logo is derived from partner.onboarding_variant or default for regular users.
export const selectCurrentLogo = (state: RootState) => {
  const fallback = PARTNER_LOGO_MAP.default;
  if (!selectIsPartner(state)) return fallback;
  return PARTNER_LOGO_MAP[state.partner.variant] || fallback;
};
